import { createAction } from 'utils/redux';

export const RECEIVE_ADMIN_CUSTOMER = 'billing-admin/receive-customer';
export const FETCH_ADMIN_CUSTOMER = 'billing-admin/fetch-customer';

export const fetchAdminCustomer = createAction(FETCH_ADMIN_CUSTOMER);
export const receiveAdminCustomer = createAction(RECEIVE_ADMIN_CUSTOMER);
